<template src="./intermediariesPage.html"></template>

<script>
import intermediaryEndpoints from '../intermediary.endpoints';
import dataTableMixin from '../../../js/dataTableMixin.js';

export default {
    name: 'intermediaries-page',
    mixins: [dataTableMixin],
    data() {
        return {
            dto: {
                SearchText: '',
                IncludeInactive: false,
                PageNumber: 1,
                PageRows: 100,
                SortByColumn: 'Name',
                SortDirection: 'asc',
            },
            intermediariesTableItems: {},
            intermediariesTableSortBy: {
                columns: [{ field: 'Name', direction: 'Ascending' }],
            },
        };
    },
    computed: {
        permissions() {
            return this.$store.state.PermissionsModule.intermediaryPermissions;
        },
        intermediariesTableColumns() { 
            let columns = [
                {
                    type: 'iconTemplate',
                    iconName: 'edit',
                    width: '35px'
                },
                {
                    key: 'Name',
                    label: 'Name',
                    allowSorting: true,
                },
                {
                    key: 'SponsorNames',
                    label: 'Programs',
                    clipMode: 'EllipsisWithTooltip',
                    allowSorting: true,
                    formatter: (column, data) => {
                        return data.SponsorNames.join(', ');
                    },
                },
                {
                    key: 'Code',
                    label: 'Code',
                    width: '100px',
                    allowSorting: true,
                },
                {
                    key: 'IsActive',
                    label: 'Status',
                    width: '100px',
                    allowSorting: false,
                    formatter: (column, data) => {
                        return data.IsActive === true ? 'Active' : 'Inactive';
                    },
                },
            ];

            if (!this.permissions.CanUpdate) {
                columns.shift();
            }

            return columns;
        }
    },
    methods: {
        getAll() {
            intermediaryEndpoints.getAll(this.dto).then((response) => {
                this.intermediariesTableItems = {
                    result: response.Rows,
                    count: response.NumberOfRecords,
                };
            });
        },
        create() {
            if (this.permissions.CanCreate) {
                let modalData = {
                    mode: 'add',
                    dto: {
                        Name: '',
                        Code: '',
                        IsActive: true,
                        PrimarySponsorID: null,
                        MinResponsesForDashboard: 0,
                        OtherSponsorIDs: [],
                    },
                    callback: this.getAll,
                };
    
                DMUtils.openApplicationModal('intermediariesEditModal', modalData);
            }
        },
        update() {
            if (this.permissions.CanUpdate) {
                let modalData = {
                    mode: 'edit',
                    dto: {},
                    callback: this.getAll,
                };
    
                intermediaryEndpoints.getByID(this.selectedRow.rowData.IntermediaryID).then((response) => {
                    modalData.dto = response;
                    DMUtils.openApplicationModal('intermediariesEditModal', modalData);
                });
            }
        },
    },
    created() {
        this.getAll();
    },
};
</script>
